var _style, _path, _g, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 130",
    style: {
      enableBackground: "new 0 0 300 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#9FB000;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 149.6668,
    cy: 23.7015,
    r: 217.0445,
    gradientTransform: "matrix(1 0 0 0.251 0 17.7532)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4715,
    style: {
      stopColor: "#0086CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9369,
    style: {
      stopColor: "#004186"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.8,43.6c-2.8,0-5.4,0.7-7.9,2.1c-2.4,1.4-4.3,3.4-5.7,5.9v-7.4h-8.6V85h8.6V62.9c0-3.8,1.1-6.7,3.3-8.6     c2.2-2,4.8-3,7.7-3c6.2,0,9.4,3.8,9.4,11.3V85h8.6V60c0-5.3-1.4-9.4-4.3-12.2C120.1,45,116.4,43.6,111.8,43.6z M166.9,48.6     c-3.9-3.3-8.6-5-14.1-5c-5.6,0-10.4,1.9-14.5,5.7c-4.1,3.8-6.1,8.9-6.1,15.3c0,6.4,2,11.5,6,15.3c4,3.8,8.9,5.7,14.6,5.7     c5.6,0,10.4-1.5,14.3-4.3l-5.2-5.2c-2.3,1.4-5.1,2.1-8.5,2.1c-2.7,0-5.2-0.7-7.4-2c-3.1-1.5-5.3-4.7-5.3-8.4l0-6.6     c0-3.4,1.8-6.3,4.5-7.9c2.3-1.6,4.9-2.4,7.8-2.4c3.1,0,5.8,0.9,7.9,2.8c2.1,1.8,3.2,4.5,3.2,7.9l-14.2,0c0,2.2,0,4.6,0,6.8     l22.9,0v-5.9C172.8,56.6,170.8,52,166.9,48.6z M63,74.3L50.8,44.2h-9.2c11,27.2,16.5,41.2,16.5,41.9c0,1.6-0.6,3.1-1.8,4.5     c-1.2,1.4-2.8,2.1-4.7,2.1c-1.9,0-3.8-0.8-5.6-2.5l-3.9,7c3,2.7,6.4,4.1,10.1,4.1c2.7,0,5.1-0.8,7.3-2.3c2.2-1.5,3.9-3.6,5-6.3     l19.8-48.5h-9.2L63,74.3z M37.7,44.6H26.9l-16.3,17V28.7H2.2v55.9h8.4V73.3l6.1-6.2l11.9,17.6h10.3L22.5,60.5L37.7,44.6z      M292.7,70.4c-2.4,4-5.5,6.4-9.1,7.3c-3.7,0.9-7.1,0.4-10.3-1.6c-3.1-1.9-5.1-4.7-6-8.4c-0.9-3.7-0.3-6.9,1.7-9.9     c2-2.9,4.8-4.8,8.2-5.6c3.5-0.8,7.3-0.2,11.4,2l3.5-7.2c-5.1-3.1-10.6-4-16.6-2.6c-6,1.4-10.6,4.5-13.8,9.3     c-3.3,4.8-4.2,10.2-2.7,16.3c1.4,6.1,4.6,10.5,9.5,13.3c4.9,2.8,10.1,3.6,15.6,2.2c5.8-1.4,10.4-4.6,14-9.8     C296,73.7,293.8,71.6,292.7,70.4z M247.2,48.6c-3.9-3.3-8.6-5-14.1-5c-5.5,0-10.4,1.9-14.5,5.7c-4.1,3.8-6.1,8.9-6.1,15.3     c0,6.4,2,11.5,6,15.3c4,3.8,8.9,5.7,14.6,5.7c5.6,0,10.4-1.5,14.3-4.3l-5.2-5.2c-2.3,1.4-5.1,2.1-8.5,2.1c-2.7,0-5.2-0.7-7.4-2     c-3.1-1.5-5.3-4.7-5.3-8.4v-6.6c0-3.4,1.8-6.3,4.5-7.9c2.3-1.6,4.9-2.4,7.8-2.4c3.1,0,5.8,0.9,7.9,2.8c2.1,1.8,3.2,4.5,3.2,7.9     l-14.2,0c0,2.2,0,4.6,0,6.8l22.9,0l0-5.9C253.1,56.6,251.1,52,247.2,48.6z M200.6,78.6c-1.7,0-3.1-0.5-4.1-1.6     c-1-1.1-1.5-2.5-1.5-4.4V34.3H187V46l-11.2,0l0,8l11.2,0v18.4c0,4.1,1.2,7.3,3.7,9.7c2.4,2.4,5.4,3.6,8.8,3.6     c3.5,0,6.6-1.3,9.5-3.8l-3.3-5.7C204.1,77.7,202.4,78.6,200.6,78.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.6,64.7c0.1,3.8-2.3,7.3-5.9,8.7c-4.7,1.8-10-0.5-11.8-5.2c-0.7-1.9-0.8-4-0.2-5.9l-2.2-0.7    c-0.8,2.4-0.7,5.1,0.3,7.5c1.8,4.5,6.1,7.3,10.7,7.3c1.4,0,2.8-0.2,4.1-0.8c4.5-1.7,7.5-6.1,7.4-10.9L289.6,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280,72.2c0.8,0,1.7-0.2,2.5-0.5l0-0.6l-0.8-1.6c-2.4,0.9-5.2-0.3-6.1-2.6c-0.4-1-0.4-2-0.1-3.1l-2.2-0.7    c-0.5,1.5-0.4,3.1,0.2,4.6C274.5,70.5,277.2,72.2,280,72.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201.9,54.7c-2.8,0-5.5,0-5.5,0s-0.1-9,7.8-9c5.2,0,5.7,0,5.7,0S209.8,54.8,201.9,54.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.412,
    y1: 75.6232,
    x2: 280.412,
    y2: 61.5195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    style: {
      stopColor: "#CDC400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#9FB000"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.6,64.5c0.1,3.6-2.3,7-5.9,8.3c-4.7,1.7-10-0.5-11.8-4.9c-0.7-1.8-0.8-3.8-0.2-5.7l-2.2-0.7    c-0.8,2.3-0.7,4.9,0.3,7.2c1.8,4.3,6.1,6.9,10.7,6.9c1.4,0,2.8-0.2,4.1-0.7c4.5-1.7,7.5-5.9,7.4-10.5L289.6,64.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.7532,
    y1: 71.5734,
    x2: 277.7532,
    y2: 62.9195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    style: {
      stopColor: "#CDC400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#9FB000"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M280,71.6c0.8,0,1.7-0.1,2.5-0.5l-0.8-2.1c-2.4,0.9-5.2-0.2-6.1-2.5c-0.4-0.9-0.4-2-0.1-2.9l-2.2-0.7    c-0.5,1.4-0.4,3,0.2,4.4C274.5,70,277.2,71.6,280,71.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.4827,
    y1: 49.8033,
    x2: 209.9207,
    y2: 49.8033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    style: {
      stopColor: "#CDC400"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    style: {
      stopColor: "#9FB000"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202,53.9c-4.8,0-5.5,0-5.5,0s-0.1-8.2,7.8-8.2c4.7,0,5.6,0,5.6,0S209.8,53.9,202,53.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fa94efbdb8bcbc002a4c671c06963cac.svg";
export { ForwardRef as ReactComponent };